import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { Card, CardBody, CitationChip, ConfidenceBadge, RiskBadge, Select, VerificationBadge } from "@odingard/design-system";
import { EmptyState, LoadingState } from "@odingard/design-system";
import { useAuth } from "../../lib/auth";
import { useAsync } from "../../lib/useAsync";
import { api } from "../../lib/api";
import { CaiError } from "../../components/CaiError";

export function CaiClauses() {
  const { activeOrg } = useAuth();
  const orgId = activeOrg?.id ?? "";
  const state = useAsync(() => api.clauses(orgId), [orgId]);
  const [risk, setRisk] = useState("");

  const rows = useMemo(() => (state.data?.clauses ?? []).filter((c) => !risk || c.riskLevel === risk), [state.data, risk]);

  return (
    <>
      <div className="page-head">
        <div>
          <h1>Clause Intelligence</h1>
          <p>Portfolio wide clause analysis with playbook findings.</p>
        </div>
        <Select value={risk} onChange={(e) => setRisk(e.target.value)} aria-label="Filter by risk">
          <option value="">All risk</option>
          <option value="high">High</option>
          <option value="medium">Medium</option>
          <option value="low">Low</option>
        </Select>
      </div>

      {state.loading && <LoadingState />}
      {state.error && <CaiError error={state.error} onRetry={state.reload} />}
      {state.data &&
        (rows.length === 0 ? (
          <EmptyState icon="⚖️" title="No clauses" description="No clauses match the current filter." />
        ) : (
          <div className="ods-stack">
            {rows.map((cl) => (
              <Card key={cl.id}>
                <CardBody>
                  <div className="ods-row" style={{ justifyContent: "space-between" }}>
                    <div>
                      <strong>{cl.clauseType}</strong>
                      <div style={{ fontSize: "var(--ods-text-sm)" }}>
                        <Link to={`/studio/contract-ai/contracts/${cl.contractId}`}>{cl.contractTitle}</Link>
                      </div>
                    </div>
                    <div className="ods-row">
                      <RiskBadge level={cl.riskLevel} />
                      <ConfidenceBadge value={cl.confidence} />
                    </div>
                  </div>
                  <p style={{ margin: "8px 0", color: "var(--ods-color-ink-2)", fontSize: "var(--ods-text-sm)" }}>{cl.text}</p>
                  {cl.playbookFinding && <div className="banner banner--warning">⚠️ {cl.playbookFinding}</div>}
                  <div className="ods-row" style={{ marginTop: 8 }}>
                    {cl.citationLocator && <CitationChip locator={cl.citationLocator} />}
                    <VerificationBadge state={cl.verification} />
                  </div>
                </CardBody>
              </Card>
            ))}
          </div>
        ))}
    </>
  );
}
